var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.75H25C27.2091 0.75 29 2.54086 29 4.75L29 5.60294C29 7.81208 27.2091 9.60294 25 9.60294H2M2 9.60294L7.78571 3.95588M2 9.60294L7.78571 15.25",
    stroke: "#393D44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoback);
export default __webpack_public_path__ + "static/media/goback.2a39299cb7e4042ff26438faee1d31d9.svg";
export { ForwardRef as ReactComponent };